import { STATUS_LABEL, type ReferralPublicStatus } from '@/services/referralsService'

const EXEMPLO: ReadonlyArray<{ empresa: string; status: ReferralPublicStatus }> = [
  { empresa: 'Loja de exemplo A', status: 'em_contato' },
  { empresa: 'Loja de exemplo B', status: 'proposta' },
  { empresa: 'Loja de exemplo C', status: 'comissao_liberada' },
]

export function ParceirosPublicPortal() {
  return (
    <section id='portal' className='grid gap-4'>
      <div className='grid gap-2'>
        <h2 className='text-2xl font-black'>O portal mostra o status de cada loja</h2>
        <p className='max-w-2xl text-sm leading-6 text-white/60'>
          São os mesmos nomes de status do portal do parceiro. As lojas abaixo são ilustração.
        </p>
      </div>
      <div className='overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-xl'>
        <table className='w-full text-left text-sm text-white'>
          <thead className='text-xs font-medium uppercase tracking-wider text-white/45'>
            <tr>
              <th className='px-5 py-3'>Loja</th>
              <th className='px-5 py-3'>Status</th>
            </tr>
          </thead>
          <tbody>
            {EXEMPLO.map((row) => (
              <tr key={row.empresa} className='border-t border-white/10'>
                <td className='px-5 py-3 font-medium'>{row.empresa}</td>
                <td className='px-5 py-3 text-white/70'>{STATUS_LABEL[row.status]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
